<style>
.iti {
  width: 100% !important;
}
.custom-placeholder:invalid {
    color: #8a8383 !important;
}
</style>
<template>
    <!-- Applicant Details -->
    <div class="col-md-8 col-lg-9 form-section p-lg-5 pt-4 px-3">
        <h5>01. Applicant Details</h5>
        <p class="mt-3">Please provide your personal and booking information.</p>
        <div class="row mt-4">
            <div class="col-md-6">
                <label class="mb-2">Your Full Name</label><small class="text-danger">*</small>
                <input type="text" v-model="fullName" :readonly="isAgent" :class="['form-control custom-placeholder', { 'is-invalid': errors.fullName }]" placeholder="Enter Your Full Name">
                <small v-if="errors.fullName" class="text-danger">{{ errors.fullName }}</small>
            </div>
            <div class="col-md-6">
                <label class="mb-2">Country</label><small class="text-danger">*</small>
                <select v-model="selectedCountry" :class="['form-control custom-placeholder', { 'is-invalid': errors.selectedCountry }]" required>
                    <option value="" selected disabled hidden>Please Select</option>
                    <option v-for="entity in entities" :key="entity.id" :value="entity.id" :disabled="selectedCountry && selectedCountry !== entity.id">
                        {{ entity.title }}
                    </option>
                </select>
                <small v-if="errors.country" class="text-danger">{{ errors.country }}</small>
            </div>
            <div class="col-md-6 mt-3">
                <label class="mb-2">Email ID</label><small class="text-danger">*</small>
                <input type="email"  v-model="email" :readonly="isAgent" :class="['form-control custom-placeholder', { 'is-invalid': errors.email }]" class="form-control custom-placeholder" placeholder="example@gmail.com">
                <small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
            </div>
            <div class="col-md-6 mt-3">
                <label class="mb-2">No of Adult</label><small class="text-danger">*</small>
                <option value="" selected disabled hidden>Please Select</option>
                <select  v-model="selectedNoOfAdult" :class="['form-control custom-placeholder', { 'is-invalid': errors.selectedNoOfAdult || errors.totalCount }]" required>
                    <option value="" selected disabled hidden>Please Select</option>
                    <!-- <option v-for="n in 6" :key="n-1" :value="n-1" :disabled="n - 1 === 0"> -->
                    <option v-for="n in 6" :key="n-1" :value="n-1">
                        {{ n - 1 }}
                    </option>
                    <!-- <option v-for="n in 11" :key="n-1" :value="n-1" :disabled="selectedNoOfAdult !== '' && selectedNoOfAdult !== (n - 1)">
                        {{ n - 1 }}
                    </option> -->
                </select>
                <small v-if="errors.selectedNoOfAdult" class="text-danger">{{ errors.selectedNoOfAdult }}</small>
            </div>
            <div class="col-md-6 mt-3">
                <label class="mb-2">Phone Number</label><small class="text-danger">*</small>
                <input type="tel" v-model="phone" :readonly="isAgent" ref="phoneInput" min="0" minlength="10" max="10" :class="['form-control custom-placeholder', { 'is-invalid': errors.phone }]" class="form-control custom-placeholder" placeholder="(000) 000-0000">
                <small v-if="errors.phone" class="text-danger">{{ errors.phone }}</small>
            </div>
            <div class="col-md-6 mt-3">
                <label class="mb-2">No of Children</label><small class="text-danger">*</small>
                <select  v-model="selectedNoOfChildren" :class="['form-control custom-placeholder', { 'is-invalid': errors.selectedNoOfChildren || errors.totalCount }]" required>
                    <option value="" selected disabled hidden>Please Select</option>
                    <option v-for="n in 6" :key="n-1" :value="n-1">
                        {{ n - 1 }}
                    </option>
                </select>
                <small v-if="errors.selectedNoOfChildren" class="text-danger">{{ errors.selectedNoOfChildren }}</small>
                <small v-if="errors.totalCount" class="text-danger">{{ errors.totalCount }}</small>
            </div>
            <!-- Instructions -->
            <div class="instruction row mt-4">
              <div class="col-12 text-end">
                <p>* Kindly Note that children age should be less than 11 years</p>
              </div>
            </div>
            <div class="row alert align-items-center">
              <div class="col-md-6 d-flex align-items-center">
                <div class="icon-box me-2">
                    <i class="fa-solid fa-exclamation"></i>
                  </div>
                <span>Total number of applicants must not exceed 5.</span>
              </div>
            <div class="col-md-6 d-flex align-items-center justify-content-end">
                <input type="checkbox" id="whatsapp-updates" class="custom-checkbox me-2" v-model="checked">
                <label for="whatsapp-updates" class="update_msg">Receive booking updates on WhatsApp</label>
            </div>
            </div>
            <!-- continue button -->
            <div class="row mt-lg-5 mb-5">
                <div class="col-12 text-center">
                    <button class="btn continue-btn w-50 px-4 py-2" @click="handleContinue" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {{ loading == true ? 'Processing...' : 'Continue' }}
                    </button>
                </div>
            </div>
        </div>  
    </div>

</template>
<script>
  import { GetEntities } from '@/api/Front/home';
  import { ParticipantRegister } from '@/api/Post/register';
  import { registerSlotsPediatricFriendly } from '@/api/Post/slot';
  import Swal from 'sweetalert2';
  import { useAgentStore } from '@/store/agent';
  export default {
    data() {
        return {
            entities: [],
            selectedCountry: '',
            selectedNoOfAdult: '',
            selectedNoOfChildren: '',
            fullName: '',
            email: '',
            phone: '',
            errors: {},
            checked: true,
            loading: false,
            iti: null,
            isAgent: false,
            agent_id: '',
        };
    },
    mounted() {
        this.loadEntities(); 
        const entiti_id = this.$route.params.id;
        const count = parseInt(this.$route.query.applicants);
        if (entiti_id) {
            this.selectedCountry = entiti_id;
        }
        if (!isNaN(count)) {
            this.selectedNoOfAdult = count; 
        }

        const agentStore = useAgentStore();
          agentStore.loadAgentDetails();  

          if (agentStore.agentDetails) {
                // console.log('Agent Details in mounted name:', agentStore.agentDetails.user.name);
                // console.log('Agent Details in mounted email:', agentStore.agentDetails.user.email);
                // console.log('Agent Details in mounted contact_no:', agentStore.agentDetails.user.contact_no);
                this.fullName= agentStore.agentDetails.user.name;
                this.email= agentStore.agentDetails.user.email;
                let contact_no = String(agentStore.agentDetails.user.contact_no).replace(/^0+/, '');
                this.phone = contact_no;
                this.agent_id= agentStore.agentDetails?.user?.agent?.id;
                // console.log('Message:', agentStore.agentDetails.message);
                this.isAgent = true;
          } else {
                const input = this.$refs.phoneInput;
                this.iti = window.intlTelInput(input, {
                initialCountry: 'in', 
                onlyCountries: ['in'], // only india other wise comment it
                separateDialCode: true,
                utilsScript:
                    'https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js',
                });

                input.addEventListener('change', this.updatePhone);
                input.addEventListener('blur', this.updatePhone);
          }
        
    },
    methods: {

        // updatePhone() {
        //     if (this.iti.isValidNumber()) {
        //         this.phone = this.iti.getNumber(); 
        //         this.errors.phone = null;
        //     } else {
        //         this.phone = '';
        //         this.errors.phone = 'Invalid phone number';
        //     }
        // },

        async loadEntities() {
            try {
                const response = await GetEntities();
                //console.log('Entities:', response.data);
                this.entities = response.data.data;
            } catch (error) {
                console.error('Failed to fetch entities:', error);
            }
        },
        async handleContinue() {
            this.errors = {};
            const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
            this.loading = true;

            if (!this.fullName.trim()) this.errors.fullName = "Full name is required.";
            else if (this.fullName.trim().length < 3) this.errors.fullName = "Full name must be at least 3 characters.";
            else if (!nameRegex.test(this.fullName.trim())) this.errors.fullName = "Full name must contain only letters and spaces.";
            else if (this.fullName.trim().length > 25) this.errors.fullName = "Full name must be less than 25 characters.";
            if (!this.email.trim()) this.errors.email = "Email is required.";
            else if (!/^\S+@\S+\.\S+$/.test(this.email)) this.errors.email = "Invalid email format.";
            if (!this.phone) this.errors.phone = "Phone number is required.";
            else if (!/^\d{10}$/.test(this.phone)) this.errors.phone = "Phone number must be 10 digits.";
            if (!this.selectedCountry) this.errors.country = "Please select a country.";

            //if (this.selectedNoOfAdult === '' || this.selectedNoOfAdult === null || this.selectedNoOfAdult === 0) {
            if (this.selectedNoOfAdult === '' || this.selectedNoOfAdult === null) {
                this.errors.selectedNoOfAdult = "Please select number of adults.";
            }
            if (this.selectedNoOfChildren === '' || this.selectedNoOfChildren === null) {
                this.errors.selectedNoOfChildren = "Please select number of children.";
            }
            const adult = Number(this.selectedNoOfAdult || 0);
            const child = Number(this.selectedNoOfChildren || 0);

            if (adult === 0 && child === 0) {
                this.errors.totalCount = "At least one applicant must be added.";
            }

            if ((adult + child) > 5) {
                this.errors.totalCount = "Total applicants must not exceed 5.";
            }

            if (Object.keys(this.errors).length > 0) {
                this.loading = false;
                return;
            }

            if (Object.keys(this.errors).length === 0) {
                const data = {
                    fullName : this.fullName,
                    email: this.email,
                    phone: this.phone,
                    country: this.selectedCountry,
                    noOfAdult: this.selectedNoOfAdult,
                    noOfChildren: this.selectedNoOfChildren,
                    whatsapp_notification: this.checked,
                }
                localStorage.setItem("bookingData", JSON.stringify(data));
                const response = await ParticipantRegister(this.fullName, this.phone, this.email, this.agent_id, this.checked);
                this.registerResponse = response.data.data;
                if (response.data.is_verified === true) {
                   /// this.loading = false;
                   this.$router.replace({
                        path: this.$route.path,
                        query: {
                            ...this.$route.query,
                            applicants: this.selectedNoOfAdult,
                            noChildren: this.selectedNoOfChildren,
                        }
                    });

                    const year = new Date().getFullYear();
                    //console.log('this.selectedNoOfChildren:', this.selectedNoOfChildren);
                    const hasChildren = this.selectedNoOfChildren ? "true" : "false";
                    registerSlotsPediatricFriendly(hasChildren, this.selectedCountry, year)
                        .then((response) => {
                            ///console.log('hai vishnu');
                            this.$emit('nextStep');
                        })
                        .catch((error) => {
                            const message = error?.response?.data?.message;

                            let alertMessage = '';
                            if (hasChildren === "true") {
                            alertMessage =
                                'Slots are not available for the selected date as children are not permitted for these appointments. Please remove children or choose a different slot.';
                            } else {
                            alertMessage =
                                'Sorry! No slots available or unable to fetch slots at this time. Please try again later.';
                            }

                            Swal.fire({
                                title: 'Sorry!',
                                text: alertMessage,
                                confirmButtonText: 'OK',
                                customClass: {
                                    popup: 'custom-error-alert',
                                    confirmButton: 'white-confirm-button'
                                },
                                showClass: {
                                    popup: 'animate__animated animate__shakeX'
                                },
                                hideClass: {
                                    popup: 'animate__animated animate__fadeOutUp'
                                }
                            });

                            this.loading = false;
                            console.error("Caught API Error:", error);
                        });


                    
                } else {
                    this.errors.email = 'Email verification failed. Please check and try again.';
                }
                
            }
        },
    }
    
  }
  </script>

<style>
.is-invalid {
    border-color: #dc3545;
}
select option:disabled {
    color: #aaa; 
    background-color: #f8f9fa; 
}
/* Global CSS (e.g., App.vue or main.css) */
.white-confirm-button {
    background-color: white !important;
    color: #e3342f !important;
    border: 2px solid #e3342f !important;
    font-weight: bold;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
}

.white-confirm-button:hover {
    background-color: #e3342f !important;
    color: white !important;
}

</style>

<style scoped>
/*  Medium screens (laptops, landscape tablets) — use 70% layout */
@media (max-width: 1920px) and (max-height: 1080px),
       (max-width: 1600px) and (max-height: 900px),
       (max-width: 1440px),
       (max-width: 1366px),
       (max-width: 1280px),
       (max-width: 1180px) and (orientation: landscape),
       (max-width: 1024px) and (orientation: landscape) {
  .side_bar {
    display: none !important;
  }
  .form-section {
    flex: 0 0 70% !important;
    max-width: 100% !important;
  }
}

/* 📱 Small devices (mobiles & tablets portrait) — use full 100% layout */
@media (max-width: 1024px) and (orientation: portrait),
       (max-width: 912px),
       (max-width: 834px),
       (max-width: 820px),
       (max-width: 768px),
       (max-width: 640px),
       (max-width: 540px),
       (max-width: 430px),
       (max-width: 414px),
       (max-width: 393px),
       (max-width: 384px),
       (max-width: 375px),
       (max-width: 360px) {
  .side_bar {
    display: none !important;
  }
  .form-section {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
@media (min-width: 1024px) and (max-width: 1366px) {
  .side_bar { display: none !important; }
  .form-section { flex: 0 0 70% !important; max-width: 100% !important; }
}
</style>


